import { NgModule } from '@angular/core';

import { LiveDeviceDiscoveryApiService } from './api/live-device-discovery-api.service';
import { LiveDeviceDiscoverySysApiService } from './api-instance-sys-api/live-device-discovery-sys-api.service';

@NgModule({
	providers: [{ provide: LiveDeviceDiscoveryApiService, useClass: LiveDeviceDiscoverySysApiService }]
})
export class DeviceDiscoveryDataAccessModule {}
